import { render, staticRenderFns } from "./BackModal.vue?vue&type=template&id=307c01a4&"
import script from "./BackModal.vue?vue&type=script&lang=ts&"
export * from "./BackModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports